module.exports = __webpack_public_path__ + "img/landing.981ee5d.jpg";